import { NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotitiesService } from './notities.service';
import { RouterModule, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, ResolveFn } from '@angular/router';
import { NotitieToevoegenComponent } from './notitie-toevoegen/notitie-toevoegen.component';
import { NotitieReageerComponent } from './notitie-reageer/notitie-reageer.component';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormsModule } from '@angular/forms';
import { NotitieZoekenComponent } from './notitie-zoeken/notitie-zoeken.component';
import { ICodeIdOmschrijving } from '../shared/global-data.service';
import { IPartij, IReageerNotitieData } from '../shared/notities/notities-common.service';
import { SharedModule } from '../shared/shared.module';

const notitieResolver : ResolveFn<string> = (route,state)=>{
    return 'edit';
}

export const notitieRoutes : Routes = [
    {
        path: 'notities',
        children: [
            { path: 'toevoegen/:zittingId/:agendapuntId', component: NotitieToevoegenComponent, /*resolve: { partijen: ActieveLedenResolver }*/ },
            { path: 'reageer/:zittingId/:agendapuntId/:notitieId', component: NotitieReageerComponent /*,resolve:{result:ReageerNotitieResolver}*/ },
            { path: 'wijzig/:zittingId/:agendapuntId/:notitieId', component: NotitieReageerComponent, resolve: { /*result:ReageerNotitieResolver,*/ edit: notitieResolver } },
            { path: 'zoeken', component: NotitieZoekenComponent }
        ]
    }
]


export interface INotitieZoekenViewData {
  partijen: ICodeIdOmschrijving[];
}


// @NgModule({
//     imports: [
//         CommonModule,
//         FormsModule,
//         SharedModule,
//         RouterModule.forChild([
           
//         ]),
//         NotitieToevoegenComponent, NotitieReageerComponent, NotitieZoekenComponent
//     ],
//     providers: [NotitiesService, /*ActieveLedenResolver, ReageerNotitieResolver,*/ { provide: 'edit', useValue: () => true }],
// })
// export class NotitiesModule { }
